<template>
  <div class="play-controls">
    <h1 class="title">{{ $t(`create.step3.videoEndingOptions.title`) }}</h1>
    <div class="buttons">
      <button
        class="control-btn"
        :class="{
          'control-btn-selected': formatObject.autoLoop,
          'disabled-btn': formatObject.isChapterActivated,
        }"
        @click="setReplay"
      >
        {{ $t(`create.step3.videoEndingOptions.replay`) }}
      </button>
      <button
        class="control-btn"
        :class="{ 'control-btn-selected': formatObject.autoScroll }"
        @click="setPlayNext"
      >
        {{ $t(`create.step3.videoEndingOptions.playNext`) }}
      </button>
      <button
        class="control-btn"
        :class="{
          'control-btn-selected':
            !formatObject.autoScroll && !formatObject.autoLoop,
        }"
        @click="setPauseAtEnd"
      >
        {{ $t(`create.step3.videoEndingOptions.pause`) }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlayControlButtons",
  props: {
    formatObject: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    setReplay() {
      if (this.formatObject.isChapterActivated) return;
      this.$emit("change-format-object", { inputFor: "autoLoop", value: true });
      this.$emit("change-format-object", {
        inputFor: "autoScroll",
        value: false,
      });
    },
    setPlayNext() {
      this.$emit("change-format-object", {
        inputFor: "autoLoop",
        value: false,
      });
      this.$emit("change-format-object", {
        inputFor: "autoScroll",
        value: true,
      });
    },
    setPauseAtEnd() {
      this.$emit("change-format-object", {
        inputFor: "autoLoop",
        value: false,
      });
      this.$emit("change-format-object", {
        inputFor: "autoScroll",
        value: false,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.play-controls {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  &:hover {
    background-color: $settings-hover;
  }
}
.title {
  @include base-font;
  @include font-small;
}

.buttons {
  display: flex;
  justify-content: center;
  width: 100%;

  .control-btn {
    align-items: center;
    background-color: transparent;
    @include base-font;
    @include font-smaller;
    display: flex;
    color: $medium-grey;
    border: 1px solid $medium-grey;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 6px 0px;
    height: 36px;
    &:hover {
      cursor: pointer;
    }
  }
  .control-btn:first-child {
    border-right: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  .control-btn:last-child {
    border-left: none;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .control-btn-selected {
    background-color: $dark-purple;
    color: white;
    border: 1px solid $dark-purple;
  }
  .disabled-btn {
    cursor: not-allowed !important;
  }
}
</style>
